// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import {
  type CitecUser,
  type UserBase,
} from '@shared/data-access/interfaces/api/engine/citec';
import { engineApi } from '@shared/data-access/api-base/citec-engine-api';
import { cleanPayload } from '@shared/data-access/utils/clean-payload';
import { userPayload } from '@shared/data-access/utils/payloads/engine';

export const userApi = engineApi.injectEndpoints({
  endpoints: build => ({
    getUser: build.query<CitecUser, void>({
      query: () => ({
        url: `/citec/user/`,
        method: 'GET',
      }),
      extraOptions: {
        useTrackPromise: true,
      },
      providesTags: [{ type: 'User', id: 'User' }],
    }),

    postUser: build.mutation<CitecUser, void>({
      query: () => ({
        url: `/citec/user/`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'User', id: 'User' }],
    }),

    updateUser: build.mutation<CitecUser, { payload: UserBase }>({
      query: ({ payload }) => ({
        url: `/citec/user/`,
        method: 'PUT',
        body: cleanPayload(payload, userPayload),
      }),
      invalidatesTags: [],
    }),
  }),
});
